import Adobe from "@/pixels/providers/adobe";
import Vue from "vue";
import * as ERRORES from "@/config/constants/step-constants";

function timeOut(time) {
  return new Promise(resolve => setTimeout(resolve, time | 0));
}

describe("Adobe", () => {
  let context = {};
  beforeEach(() => {
    context = {
      mutation: {
        payload: {
          params: {
            mje: ERRORES.INDIVIDUO_NEGATIVO
          }
        }
      },
      state: {
        adobeTargetExperience: "ab_cd",
        paso1: {
          cuit: "20-32323232-3"
        }
      }
    };

    Vue.$log = {
      info: jest.fn(),
      error: jest.fn()
    };

    global.navigator = {
      userAgent:
        "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537"
    };

    jest.spyOn(Adobe, "enable");
    jest.spyOn(Adobe, "wait");
    jest.spyOn(Adobe, "init");
    jest.spyOn(Adobe, "appStartedClick");
    jest.spyOn(Adobe, "appOnClickStart");
    jest.spyOn(Adobe, "paso1");
    jest.spyOn(Adobe, "paso2");
    jest.spyOn(Adobe, "paso3");
    jest.spyOn(Adobe, "paso4");
    jest.spyOn(Adobe, "gracias");
    jest.spyOn(Adobe, "mensaje");

    window._satellite = {};
    window.digitalLink = {};
    window.digitalView = () => ({});
    window.digitalData = {
      application: {
        application: {
          type: "formulario",
          name: `contacto empresa`
        }
      },
      internalCampaign: {
        attributes: [
          {
            location: "",
            campaignFormat: "",
            collectiveCode: "",
            campaignName: "",
            product: "",
            productCode: "",
            quantity: ""
          }
        ]
      }
    };
  });

  it("configuracion exportada por defecto", () => {
    expect(Adobe).toBeDefined();
    expect(Adobe).not.toBeNull();
  });

  it("configuracion por defecto para Enable", () => {
    Adobe.enable();
    const enableMock = jest.spyOn(Adobe, "enable");
    expect(enableMock).toHaveBeenCalledTimes(1);
  });

  it("configuracion por defecto para Wait", () => {
    Adobe.wait();
    const waitMock = jest.spyOn(Adobe, "wait");
    expect(waitMock).toHaveBeenCalledTimes(1);
  });

  it("configuracion por defecto para init", () => {
    Adobe.init();
    const initMock = jest.spyOn(Adobe, "init");
    expect(initMock).toHaveBeenCalledTimes(1);
    Object.defineProperty(navigator, "userAgent", { value: "iPhone" });
    global.navigator = {
      userAgent: "iphone"
    };
    Adobe.init();
    expect(initMock).toHaveBeenCalledTimes(2);
  });

  it("Validamos si se llaman las funciones con condiciones true", async () => {
    context.mutation.payload = "payload";

    Adobe.appStartedClick(context);
    const appStartedClickMock = jest.spyOn(Adobe, "appStartedClick");
    expect(appStartedClickMock).toHaveBeenCalledTimes(1);

    Adobe.appOnClickStart(context);
    const appOnClickStartMock = jest.spyOn(Adobe, "appOnClickStart");
    expect(appOnClickStartMock).toHaveBeenCalledTimes(1);

    Adobe.paso1(context);
    const paso1Mock = jest.spyOn(Adobe, "paso1");
    expect(paso1Mock).toHaveBeenCalledTimes(1);

    Adobe.paso2(context);
    const paso2Mock = jest.spyOn(Adobe, "paso2");
    expect(paso2Mock).toHaveBeenCalledTimes(1);

    Adobe.paso3(context);
    const paso3Mock = jest.spyOn(Adobe, "paso3");
    expect(paso3Mock).toHaveBeenCalledTimes(1);

    Adobe.paso4(context);
    const paso4Mock = jest.spyOn(Adobe, "paso4");
    expect(paso4Mock).toHaveBeenCalledTimes(1);

    Adobe.gracias(context);
    const graciasMock = jest.spyOn(Adobe, "gracias");
    expect(graciasMock).toHaveBeenCalledTimes(1);

    await timeOut(500);
  });

  it("Valida paso2 con cuit empresa", async () => {
    context.state.paso1.cuit = "30-25123456-8";

    Adobe.paso2(context);
    const paso2Mock = jest.spyOn(Adobe, "paso2");
    expect(paso2Mock).toHaveBeenCalledTimes(2);

    await timeOut(500);
  });

  it("Validamos switch case (INDIVIDUO_NEGATIVO) en funcion mensaje", async () => {
    Adobe.mensaje(context);
    const mensajeMock = jest.spyOn(Adobe, "mensaje");
    expect(mensajeMock).toHaveBeenCalledTimes(1);
    await timeOut(500);
  });

  it("Validamos switch case (INDIVIDUO_NEGATIVO y CUIT EMPRESA) en funcion mensaje", async () => {
    context.state.paso1.cuit = "30-25123456-8";
    Adobe.mensaje(context);
    const mensajeMock = jest.spyOn(Adobe, "mensaje");
    expect(mensajeMock).toHaveBeenCalledTimes(2);
    await timeOut(500);
  });

  it("Validamos switch case (default) en funcion mensaje", async () => {
    context.mutation.payload.params.mje = "default";
    Adobe.mensaje(context);
    const mensajeMock = jest.spyOn(Adobe, "mensaje");
    expect(mensajeMock).toHaveBeenCalledTimes(3);
    await timeOut(500);
  });
});
